import actions from './actions'

const report = {
  state: null,
  mutations: null,
  actions
}

export default report



// WEBPACK FOOTER //
// ./src/store/report/index.js